import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeApiCall} from "../../Api/makeApiCall";
import ReactTable from "../Components/ReactTable";
import ReIngest from "../IngestionLogs/Columns/ReIngest";
import FileLink from "../IngestionLogs/Columns/FileLink";
import _ from "lodash";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import {ShowFilePartial} from "../IngestionLogs/Columns/ShowFilePartial";
import {CONFIG_TYPES} from "../Configurations/FileTypes";
import ButtonLoader from "../../utils/components/ButtonLoader";


const RetailerFiles = ({fileType, retailerId}) => {
    const gscDirectoryPrefix = `gs://spins-edp-${process.env.REACT_APP_ENV}-archive/p_data=${fileType}/p_retailer_id=${retailerId}/`
    const [retailerFilesList, updateRetailerFilesList] = useState([]);
    const [loading, updateLoading] = useState(false);
    const [triggerRefresh, setTriggerRefresh] = useState(Date.now());

    const RETAILER_FILES_COLUMNS = [
        {
            header: 'Archived Time',
            accessorKey: 'timeCreated',
            size: 28
        },
        {
            header: 'FTP',
            accessorKey: 'ftp',
            size: 28
        },
        {
            header: 'File',
            accessorKey: 'uniqueArchiveFileName',
            minSize: 500,
            filterFn: (row, columnIds, filterValue) => {
                return row.original?.uniqueArchiveFileName.toUpperCase().includes(filterValue.toUpperCase());
            },
            cell: ({row, getValue}) =>
                <FileLink
                    displayText={getValue()}
                    gcsFileLocation={row.original.fullFilePath}
                />
        },
        {
            header: 'Actions',
            accessorKey: 'fullFilePath',
            enableColumnFilter: false,
            cell: ({row, getValue}) => {
                const fileName = row.original.uniqueArchiveFileName;
                return <div className={'retailer-files-actions-row'}>
                    <div className={'retailer-files-actions-column'}>
                        <ShowFilePartial path={row.original.fullFilePath}
                                         ftp={row.original.ftp}
                                         fileType={Object.values(CONFIG_TYPES).find(config => config.getName() === fileType)}/>
                    </div>
                    <div className={'retailer-files-actions-column'}>
                        <ReIngest className='original' original={row.original} value={getValue()}/>
                    </div>
                    <div className={'retailer-files-actions-column'}>
                        <ButtonLoader buttonTitle={'Ignore'}
                                      url={`${process.env.REACT_APP_EDP_API_BASE_URL}/ignoreFile/?archiveLocation=${encodeURIComponent(row.original.fullFilePath)}`}
                                      toastTextSuccess={`${fileName} has successfully been ignored`}
                                      toastTextFailure={`${fileName} has failed to be ignored.`}
                                      buttonHasModal={true}
                                      onSubmitCallback={() => setTriggerRefresh(Date.now())}
                                      modalText={<div data-testid={'ignore_modal_text'}>
                                          Are you sure you want to move <span style={{fontWeight: "bolder"}}>{fileName}</span> to ignored?
                                      </div>}
                        />
                    </div>
                </div>
            },
            size: 30
        }
    ]

    React.useEffect(() => {
        const listBlobsUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/listGcsFiles?url=`
        const fileRegex = new RegExp("p_ftp=([^\\/]*)\\/(.*)");
        updateLoading(true)
        makeApiCall(`${listBlobsUrl}${gscDirectoryPrefix}`)
            .then(results => {
                const files = results.map(file => ({file, ftpMatch: fileRegex.exec(file.url)}))
                    .filter(({ftpMatch}) => ftpMatch)
                    .map(({file, ftpMatch}) => {
                        const retailerFtp = ftpMatch[1]
                        return {
                            fullFilePath: file.url,
                            ftp: retailerFtp,
                            uniqueArchiveFileName: ftpMatch[2],
                            retailerId,
                            isBulk: false,
                            timeCreated: file.timeCreatedChicago?.substring(0, 19)
                        }
                    })
                updateRetailerFilesList(files)
                return files;
            }).finally(() => updateLoading(false))
    }, [fileType, retailerId, gscDirectoryPrefix, triggerRefresh])

    return <>
        <LoadingWrapper loading={loading}>
            {!_.isEmpty(retailerFilesList) ? <ReactTable
                    data={retailerFilesList}
                    columns={RETAILER_FILES_COLUMNS}
                    filterable
                    initialState={{sorting: [{id: 'timeCreated',desc: true}]}}
                /> :
                <div className={"retailer-files-no-data-found"}>
                    <FileLink
                        displayText={"No Data Found"}
                        gcsFileLocation={gscDirectoryPrefix}
                    />
                </div>}
        </LoadingWrapper>
    </>;
};

RetailerFiles.propTypes = {
    fileType: PropTypes.string.isRequired,
    retailerId: PropTypes.number.isRequired
};

export default RetailerFiles;